import { Calendar } from 'primereact/calendar';

import "./InputCalendar.scss"

export default function({value, onChange}) {
    return(<div className='inputCalendar'>
        <Calendar value={value} onChange={onChange} dateFormat="dd/mm/yy" />
    </div>)
}